import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

interface Props {
  title?: string;
  subtitle?: string;
  copy?: string;
  heading1?: string;
}

export const CopyBlock: React.FC<Props> = props => {
  return (
    <Stack
      sx={{
        maxWidth: '700px',
        marginLeft: 'auto',
        marginRight: 'auto',
        padding: '2rem 0 2rem 0',
      }}
    >
      <Box>
        {props.subtitle ? (
          <Typography
            variant="subtitle1"
            component="p"
            textAlign={'center'}
            color={'secondary.light'}
          >
            {props.subtitle}
          </Typography>
        ) : null}

        {props.heading1 ? (
          <Typography
            variant="h4"
            component="h1"
            textAlign={'center'}
            sx={{
              position: 'relative',
              marginBottom: '1.5rem',
              '&:after': {
                width: '45px!important',
                height: '1px!important',
                backgroundColor: 'primary.main',
                content: '""',
                position: 'absolute',
                margin: 'auto',
                bottom: '-10px',
                left: '0',
                right: '0',
              },
            }}
          >
            {props.heading1}
          </Typography>
        ) : null}

        {props.title ? (
          <Typography
            variant="h4"
            component="h2"
            textAlign={'center'}
            sx={{
              position: 'relative',
              marginBottom: '1.5rem',
              '&:after': {
                width: '45px!important',
                height: '1px!important',
                backgroundColor: 'primary.main',
                content: '""',
                position: 'absolute',
                margin: 'auto',
                bottom: '-10px',
                left: '0',
                right: '0',
              },
            }}
          >
            {props.title}
          </Typography>
        ) : null}

        {props.copy ? <Typography textAlign={'center'}>{props.copy}</Typography> : null}
      </Box>
    </Stack>
  );
};
